export const STOCKS = [
  { id: 'o2-systems', name: 'O2 Systems', ticker: 'AAPL', icon: '🫁', category: 'large-cap', description: 'Oxygen supply for all crewmates' },
  { id: 'impostor-knives', name: 'Impostor Knives', ticker: 'NVDA', icon: '🔪', category: 'tech', description: 'Premium elimination tools' },
  { id: 'reactor-power', name: 'Reactor Power', ticker: 'TSLA', icon: '⚡', category: 'volatile', description: 'Next-gen reactor energy solutions' },
  { id: 'medbay-corp', name: 'MedBay Corp', ticker: 'JNJ', icon: '💊', category: 'stable', description: 'Scan technology & medical supplies' },
  { id: 'mira-hq-holdings', name: 'MIRA HQ Holdings', ticker: 'MSFT', icon: '🏢', category: 'large-cap', description: 'Interstellar headquarters management' },
  { id: 'electrical-co', name: 'Electrical Co', ticker: 'AMZN', icon: '💡', category: 'large-cap', description: 'Ship-wide wiring infrastructure' },
  { id: 'cafeteria-foods', name: 'Cafeteria Foods', ticker: 'MCD', icon: '🍔', category: 'stable', description: 'Space food & crew nutrition' },
  { id: 'navigation-tech', name: 'Navigation Tech', ticker: 'GOOGL', icon: '🧭', category: 'large-cap', description: 'Stellar mapping & course plotting' },
  { id: 'security-cams', name: 'Security Cams Inc', ticker: 'META', icon: '📷', category: 'tech', description: 'Surveillance & crew monitoring' },
  { id: 'vent-network', name: 'Vent Network', ticker: 'BTC-USD', icon: '🕳️', category: 'crypto', description: 'Underground transport systems' },
  { id: 'emergency-button', name: 'Emergency Button Ltd', ticker: 'ETH-USD', icon: '🚨', category: 'crypto', description: 'Emergency meeting infrastructure' },
  { id: 'skeld-industries', name: 'Skeld Industries', ticker: 'SPY', icon: '🚀', category: 'index', description: 'Diversified space fleet operations' },
  { id: 'polus-mining', name: 'Polus Mining', ticker: 'GME', icon: '⛏️', category: 'meme', description: 'Asteroid mining & specimen collection' },
  { id: 'airship-logistics', name: 'Airship Logistics', ticker: 'DOGE-USD', icon: '✈️', category: 'crypto', description: 'Interplanetary cargo transport' },
  { id: 'crewmate-union', name: 'Crewmate Union', ticker: 'WMT', icon: '👷', category: 'stable', description: 'Worker benefits & task management' },
  { id: 'sabotage-systems', name: 'Sabotage Systems', ticker: 'AMD', icon: '💣', category: 'tech', description: 'Advanced disruption technology' },
  { id: 'silly-coin', name: 'Silly Coin', ticker: 'BONK-USD', icon: '🐕', category: 'crypto', description: 'Tiny but mighty meme currency' },
  { id: 'task-bar-index', name: 'Task Bar Index', ticker: 'QQQ', icon: '📊', category: 'index', description: 'Top 100 space-tech task completion tracker' },
  { id: 'comms-entertainment', name: 'Comms Entertainment', ticker: 'NFLX', icon: '📡', category: 'tech', description: 'Ship-wide streaming & comms relay' },
  { id: 'specimen-labs', name: 'Specimen Labs', ticker: 'DIS', icon: '🧪', category: 'stable', description: 'Alien specimen research & theme parks' },
];

export const STOCK_CATEGORIES = {
  'large-cap': { label: 'Large Cap', color: '#60A5FA' },
  'tech': { label: 'Tech', color: '#A78BFA' },
  'volatile': { label: 'Volatile', color: '#F97316' },
  'stable': { label: 'Stable', color: '#4ADE80' },
  'crypto': { label: 'Crypto', color: '#FBBF24' },
  'index': { label: 'Index', color: '#6EE7B7' },
  'meme': { label: 'Meme', color: '#F472B6' },
};

// Price scaling: real stock price is divided by this to get "token price"
// This makes all stocks affordable (roughly $0.10 - $100 token range)
export const PRICE_SCALE = 10;

export function getStockById(id) {
  return STOCKS.find(s => s.id === id);
}

export function getStockByTicker(ticker) {
  return STOCKS.find(s => s.ticker === ticker);
}

/** Format a price smartly — shows enough decimal places for tiny prices like BONK */
export function formatPrice(price) {
  if (price === 0 || price === null || price === undefined) return '$0.00';
  const abs = Math.abs(price);
  if (abs >= 1) return `$${price.toFixed(2)}`;
  if (abs >= 0.01) return `$${price.toFixed(4)}`;
  // For very small prices, show significant digits
  const str = price.toFixed(10);
  const match = str.match(/^-?0\.(0*[1-9]\d{0,2})/);
  if (match) return `$${match[0]}`;
  return `$${price.toFixed(8)}`;
}
